/**
 * Cross-instance coordination so only one PortalDropdown menu is open at a time.
 *
 * Each PortalDropdown keeps its open state in per-instance React state, and its
 * toggle/menu handlers stop click propagation (so card-level click handlers don't
 * fire behind the menu) — which also suppresses react-bootstrap's outside-click
 * close. Without this registry, clicking a second "…" toggle opens its menu while
 * the first one stays open.
 */
const openCloseHandlers = new Set();

/**
 * Claim the single "open dropdown" slot, closing any other dropdown that holds it.
 *
 * @param {Function} close - closes the claiming dropdown
 * @returns {Function} releases the claim; call when the dropdown closes or unmounts
 */
export default function claimOpenDropdown(close) {
  openCloseHandlers.forEach((otherClose) => {
    if (otherClose === close) return;

    // Drop it before closing so the closed dropdown's own release() is a no-op.
    openCloseHandlers.delete(otherClose);
    otherClose();
  });

  openCloseHandlers.add(close);

  return () => openCloseHandlers.delete(close);
}
